import React from "react";
import "./VaranousLife.css";
import Footer from "../Footer/Footer";
const VaranousLife = () => {
  return (
    <div>
 
      <div className="page-container">
  <section className="sz-life-section">
    <div className="sz-hero-banner varanous-hero-banner">
      <div className="sz-hero-text">
        <h1 className="sz-title">Varanous Life</h1>
      </div>
    </div>

    <div className="sz-content-wrapper">
      <h2 className="sz-heading">Connect and Celebrate – Varanous Way</h2>
      <p className="sz-description">
        At Varanous, we believe that moments of fun and togetherness
        foster a strong sense of community, boost team spirit, and enhance
        overall well-being. Whether it's the vibrant energy of a festival
        celebration, the friendly competition of sports day, or the
        creative expression during cultural programs, these events provide
        a refreshing break from routine and encourage a healthy work-life
        balance. For us, fun is not a distraction from work—it’s a vital
        part of what makes our workplace thrive. It reflects the inclusive
        and dynamic culture that defines Varanous.
      </p>
    </div>
  </section>
</div>
      <Footer />
    </div>
  );
};

export default VaranousLife;
